import React, {Component} from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {graphql} from 'react-apollo'
import {Card, CardBody, Button, Progress, Table} from 'reactstrap'
import {UnmountClosed} from 'react-collapse'
import {Link} from 'react-router-dom'
import ConfirmModal from '../Alerts/ConfirmModal'
import {API_BASE_URL} from '../../utils/apiConfig'
import {GET_JOBS} from './graphql'

class JobInfoBox extends Component {

  constructor(props) {
    super(props)
    this.state = {
      collapseIsOpen: false,
      visibleOffAlert: false,
      isHidden: false
    }
    this.toggleBtnCollapse = this.toggleBtnCollapse.bind(this)
    this.toggleVisibleOffAlert = this.toggleVisibleOffAlert.bind(this)
    this.visibleOffJob = this.visibleOffJob.bind(this)
    this.setProgressBarColor = this.setProgressBarColor.bind(this)
    this.renderImportValidations = this.renderImportValidations.bind(this)
  }

  static propTypes = {
    job: PropTypes.object.isRequired,
    mutate: PropTypes.func.isRequired,
    key: PropTypes.string,
    onJobHidden: PropTypes.func
  };

  setProgressBarColor() {
    switch (this.props.job.status) {
    case 'complete':
      return 'success'
    case 'in_progress':
      return 'warning'
    case 'error':
      return 'danger'
    default:
    }
  }

  toggleBtnCollapse() {
    this.setState({collapseIsOpen: !this.state.collapseIsOpen})
  }

  toggleVisibleOffAlert() {
    this.setState({visibleOffAlert: !this.state.visibleOffAlert})
  }

  visibleOffJob() {
    this.props.mutate({
      variables: {id: Number(this.props.job.id)},
      update: (cache) => {
        const data = cache.readQuery({ query: GET_JOBS })
        const updatedJobs = data.user_jobs.map(job => 
          job.id === this.props.job.id ? { ...job, visible: false } : job
        )
        cache.writeQuery({
          query: GET_JOBS,
          data: { user_jobs: updatedJobs }
        })
      }
    }).then(() => {
      this.toggleVisibleOffAlert()
    }).catch(error => {
      console.error('Error disabling job visibility:', error)
      this.toggleVisibleOffAlert()
    })
  }

  renderImportValidations() {
    let parsedValidations = JSON.parse(this.props.job.validation)

    return parsedValidations.map((record, idx) => {
      let recE = []
      for (const [row, errors] of Object.entries(record)) {
        recE.push(
          <tr key={idx}>
            <td>{row}</td>
            <td>{this.renderRowErrors(errors)}</td>
          </tr>
        )
      }
      return recE
    })
  }

  renderRowErrors(errors) {
    let arrE = []
    for (const [key, value] of Object.entries(errors)) {
      arrE.push(<p key={key}><b>{key}</b>- {value.join(', ')}</p>)
    }
    return arrE
  }

  notification(type, args) {
    switch(type) {
    case 'WlWelds::Jobs::ImportWeld':
      return 'Import Welds'
    case 'WlWelds::Jobs::FinalReport':
      return 'Final report'
    case 'WlWelders::Jobs::ExportWelders':
      return 'Export welders'
    case 'WlWelds::Jobs::ExportWps':
      return 'Export WPS'
    case 'WlWelds::Jobs::ExportWeldsList': {
      const format = args && args.format
      if (format === 'xlsx_inspection_groups' || format === 'pdf_inspection_groups') return 'Export Grouped Welds'
      return 'Export Welds List'
    }
    case 'WlWelds::Jobs::ProjectDefectivenessReport':
      return 'Defectiveness Report'
    default:
      return null
    }
  }

  render() {
    if (this.state.isHidden) {
      return null
    }

    const job_type = this.notification(this.props.job.type, this.props.job.args)

    return (
      <div className="callout callout-import-box">
        <ConfirmModal
          isOpened={!!this.state.visibleOffAlert}
          onCancel={this.toggleVisibleOffAlert}
          onConfirm={this.visibleOffJob}
          headerText='Disable Visability'
          bodyText='Are you sure you want to disable visability?'
          confirmBtnText='Disable'
        />
        <div key={this.props.key}>
          <div className="text-uppercase mb-1 mt-4">
            <b>{job_type}</b>
            <br/>
            <small>
              <b>{this.props.job.created_at}</b>
              <br/>
              {this.props.job.project && <Link to={`/projects/welds/${this.props.job.project.id}`}>
                <b>{this.props.job.project.name}</b>
              </Link>}
            </small>
          </div>
          {this.props.job.progress}%
          <Progress className="progress-xs" color={this.setProgressBarColor()} value={this.props.job.progress}/>
          <small className="text-muted">status: {this.props.job.status}</small>
          <br/>
          {this.props.job.status === 'invalid_file' &&
          <Button
            color="primary"
            style={{marginBottom: '1rem', marginRight: '5px'}}
            onClick={this.toggleBtnCollapse}
          > {this.state.collapseIsOpen ? 'Close' : 'Info'}
          </Button>
          }
          <Button
            color="danger"
            style={{marginBottom: '1rem', marginRight: '5px'}}
            onClick={this.toggleVisibleOffAlert}
          > <i className="fa fa-eye"/>
          </Button>

          {this.props.job.attachment &&
          <a href={API_BASE_URL + this.props.job.attachment.url} target='blank'>
            <Button color="success" style={{marginBottom: '1rem'}}>
              <i className="fa fa-arrow-down"/>
            </Button>
          </a>
          }
          <UnmountClosed isOpened={this.state.collapseIsOpen}>
            <Card>
              <CardBody>
                <small>
                  <Table>
                    <thead>
                      <tr>
                        <th>Row</th>
                        <th>Errors</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.job.validation && this.renderImportValidations()}
                    </tbody>
                  </Table>
                </small>
              </CardBody>
            </Card>
          </UnmountClosed>
        </div>
      </div>
    )
  }
}

const VisibleOffJobs = gql`
  mutation visibleOffJobs($id: ID!) {
    visibleOffJobs(id: $id) {
      response
    }
  }
`

const JobWithMutation = graphql(VisibleOffJobs)(JobInfoBox)

export default JobWithMutation



// WEBPACK FOOTER //
// ./src/components/JobsNotifications/JobInfoBox.js